module.exports = flarum.core.compat['components/UserCard'];